import React, { useState } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { handleAxiosError, useModals } from 'core/notifications';

import NewItemFormButtons from './newItemFormButtons';
import PublishLocalesModalDropdown from './publishLocalesModalDropdown';
import PublishLocalesModalSelected from './publishLocalesModalSelected';

import styles from '../styles/publishLocalesModal.module.css';

const PublishLocalesModal = ({
  handlePublishLocales = () => {},
  hasUnpublishedChanges = false,
  locale = null,
  locales = [],
  publishedAt = null,
  isPublished = false,
  updatedAt = null,
  status = null,
}) => {
  const [selectedLocales, setSelectedLocales] = useState([]);
  const { removeModal } = useModals();

  const handleCheckboxChange = (key) => {
    if (selectedLocales.includes(key)) {
      setSelectedLocales(selectedLocales.filter((selectedLocale) => selectedLocale !== key));
    } else {
      setSelectedLocales([...selectedLocales, key]);
    }
  };

  const handleSubmit = async () => {
    try {
      handlePublishLocales({ locale, selectedLocales });
    } catch (error) {
      return handleAxiosError(error);
    }

    removeModal();
  };

  const handleCancel = () => removeModal();

  return (
    <>
      <div className={styles.element}>
        <PublishLocalesModalSelected
          hasUnpublishedChanges={hasUnpublishedChanges}
          isPublished={isPublished}
          locale={locale}
          publishedAt={publishedAt}
          status={status}
          updatedAt={updatedAt}
        />
        <PublishLocalesModalDropdown
          currentLocale={locale}
          handleCheckboxChange={handleCheckboxChange}
          locales={locales}
          selectedLocales={selectedLocales}
        />
      </div>
      <NewItemFormButtons 
        isFullScreen={false}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        submitText={i18n.t('publish')}
      /> 
    </>
  );
};

PublishLocalesModal.propTypes = {
  handlePublishLocales: PropTypes.func,
  hasUnpublishedChanges: PropTypes.bool,
  isPublished: PropTypes.bool,
  locale: PropTypes.string,
  locales: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      locale: PropTypes.string,
      published_at: PropTypes.string,
      state: PropTypes.string,
      has_unpublished_changes: PropTypes.bool,
      is_published: PropTypes.bool,
      version_state_updated_at: PropTypes.string
    }),
  ),
  publishedAt: PropTypes.string,
  status: PropTypes.oneOf(['approved', 'editing', 'in_review', 'in_translation', null]),
  updatedAt: PropTypes.string,
};

export default PublishLocalesModal;
